// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400&family=Montserrat:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --wine: #722F37;
  --burgundy: #800020;
  --maroon: #800000;
  --dark-pink: #C2185B;
  --violet: #7B1FA2;
  --purple: #6A1B9A;
  --beige: #F5F0E8;
  --cream: #FAF7F2;
  --gold: #C9A84C;
  --white: #FFFFFF;
  --black: #1A1A1A;
  --gray: #6B6B6B;
  --light-gray: #E8E0D8;
  --gradient-primary: linear-gradient(135deg, var(--burgundy) 0%, var(--violet) 100%);
  --gradient-warm: linear-gradient(135deg, var(--wine) 0%, var(--dark-pink) 100%);
  --gradient-royal: linear-gradient(135deg, var(--maroon) 0%, var(--purple) 100%);
  --shadow: 0 4px 20px rgba(114, 47, 55, 0.15);
  --shadow-hover: 0 8px 30px rgba(114, 47, 55, 0.25);
  --font-display: 'Cormorant Garamond', serif;
  --font-body: 'Montserrat', sans-serif;
  --nav-height: 70px;
}

* { margin: 0; padding: 0; box-sizing: border-box; }

body {
  font-family: var(--font-body);
  background-color: var(--cream);
  color: var(--black);
  overflow-x: hidden;
}

h1, h2, h3, h4 { font-family: var(--font-display); }

a { text-decoration: none; color: inherit; }

button { cursor: pointer; border: none; background: none; font-family: var(--font-body); }

input, textarea, select {
  font-family: var(--font-body);
  outline: none;
}

::-webkit-scrollbar { width: 6px; }
::-webkit-scrollbar-track { background: var(--beige); }
::-webkit-scrollbar-thumb { background: var(--burgundy); border-radius: 3px; }

.page-container { min-height: 100vh; background: var(--cream); }

.btn-primary {
  background: var(--gradient-primary);
  color: var(--white);
  padding: 10px 24px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}
.btn-primary:hover { box-shadow: var(--shadow-hover); transform: translateY(-1px); opacity: 0.92; }

.btn-outline {
  background: transparent;
  color: var(--burgundy);
  padding: 10px 24px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: all 0.3s ease;
  border: 1.5px solid var(--burgundy);
  cursor: pointer;
}
.btn-outline:hover { background: var(--burgundy); color: var(--white); }

.section-heading {
  font-family: var(--font-display);
  font-size: clamp(28px, 4vw, 42px);
  font-weight: 300;
  letter-spacing: 2px;
  color: var(--burgundy);
  text-align: center;
  padding: 40px 20px 20px;
}
.section-heading span { color: var(--violet); font-style: italic; }

.heading-bar {
  background: var(--gradient-primary);
  color: var(--white);
  text-align: center;
  padding: 16px 20px;
  font-family: var(--font-display);
  font-size: 24px;
  font-weight: 300;
  letter-spacing: 3px;
  text-transform: uppercase;
}

/* Overlay */
.overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 100;
  backdrop-filter: blur(2px);
}

/* Toast override */
.Toastify__toast { font-family: var(--font-body); font-size: 13px; }
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mFAAmF;EACnF,+EAA+E;EAC/E,+EAA+E;EAC/E,4CAA4C;EAC5C,kDAAkD;EAClD,2CAA2C;EAC3C,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,IAAI,SAAS,EAAE,UAAU,EAAE,sBAAsB,EAAE;;AAEnD;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB,gCAAgC,EAAE;;AAEnD,IAAI,qBAAqB,EAAE,cAAc,EAAE;;AAE3C,SAAS,eAAe,EAAE,YAAY,EAAE,gBAAgB,EAAE,6BAA6B,EAAE;;AAEzF;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA,sBAAsB,UAAU,EAAE;AAClC,4BAA4B,wBAAwB,EAAE;AACtD,4BAA4B,2BAA2B,EAAE,kBAAkB,EAAE;;AAE7E,kBAAkB,iBAAiB,EAAE,wBAAwB,EAAE;;AAE/D;EACE,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AACA,qBAAqB,+BAA+B,EAAE,2BAA2B,EAAE,aAAa,EAAE;;AAElG;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mCAAmC;EACnC,eAAe;AACjB;AACA,qBAAqB,2BAA2B,EAAE,mBAAmB,EAAE;;AAEvE;EACE,gCAAgC;EAChC,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;AACA,wBAAwB,oBAAoB,EAAE,kBAAkB,EAAE;;AAElE;EACE,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,eAAe,EAAE,QAAQ;EACzB,2BAA2B;EAC3B,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB,mBAAmB,6BAA6B,EAAE,eAAe,EAAE","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400&family=Montserrat:wght@300;400;500;600&display=swap');\n\n:root {\n  --wine: #722F37;\n  --burgundy: #800020;\n  --maroon: #800000;\n  --dark-pink: #C2185B;\n  --violet: #7B1FA2;\n  --purple: #6A1B9A;\n  --beige: #F5F0E8;\n  --cream: #FAF7F2;\n  --gold: #C9A84C;\n  --white: #FFFFFF;\n  --black: #1A1A1A;\n  --gray: #6B6B6B;\n  --light-gray: #E8E0D8;\n  --gradient-primary: linear-gradient(135deg, var(--burgundy) 0%, var(--violet) 100%);\n  --gradient-warm: linear-gradient(135deg, var(--wine) 0%, var(--dark-pink) 100%);\n  --gradient-royal: linear-gradient(135deg, var(--maroon) 0%, var(--purple) 100%);\n  --shadow: 0 4px 20px rgba(114, 47, 55, 0.15);\n  --shadow-hover: 0 8px 30px rgba(114, 47, 55, 0.25);\n  --font-display: 'Cormorant Garamond', serif;\n  --font-body: 'Montserrat', sans-serif;\n  --nav-height: 70px;\n}\n\n* { margin: 0; padding: 0; box-sizing: border-box; }\n\nbody {\n  font-family: var(--font-body);\n  background-color: var(--cream);\n  color: var(--black);\n  overflow-x: hidden;\n}\n\nh1, h2, h3, h4 { font-family: var(--font-display); }\n\na { text-decoration: none; color: inherit; }\n\nbutton { cursor: pointer; border: none; background: none; font-family: var(--font-body); }\n\ninput, textarea, select {\n  font-family: var(--font-body);\n  outline: none;\n}\n\n::-webkit-scrollbar { width: 6px; }\n::-webkit-scrollbar-track { background: var(--beige); }\n::-webkit-scrollbar-thumb { background: var(--burgundy); border-radius: 3px; }\n\n.page-container { min-height: 100vh; background: var(--cream); }\n\n.btn-primary {\n  background: var(--gradient-primary);\n  color: var(--white);\n  padding: 10px 24px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  transition: all 0.3s ease;\n  border: none;\n  cursor: pointer;\n}\n.btn-primary:hover { box-shadow: var(--shadow-hover); transform: translateY(-1px); opacity: 0.92; }\n\n.btn-outline {\n  background: transparent;\n  color: var(--burgundy);\n  padding: 10px 24px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  transition: all 0.3s ease;\n  border: 1.5px solid var(--burgundy);\n  cursor: pointer;\n}\n.btn-outline:hover { background: var(--burgundy); color: var(--white); }\n\n.section-heading {\n  font-family: var(--font-display);\n  font-size: clamp(28px, 4vw, 42px);\n  font-weight: 300;\n  letter-spacing: 2px;\n  color: var(--burgundy);\n  text-align: center;\n  padding: 40px 20px 20px;\n}\n.section-heading span { color: var(--violet); font-style: italic; }\n\n.heading-bar {\n  background: var(--gradient-primary);\n  color: var(--white);\n  text-align: center;\n  padding: 16px 20px;\n  font-family: var(--font-display);\n  font-size: 24px;\n  font-weight: 300;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n}\n\n/* Overlay */\n.overlay {\n  position: fixed; inset: 0;\n  background: rgba(0,0,0,0.5);\n  z-index: 100;\n  backdrop-filter: blur(2px);\n}\n\n/* Toast override */\n.Toastify__toast { font-family: var(--font-body); font-size: 13px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
